import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=124489ce&scoped=true&"
import script from "./confirm.vue?vue&type=script&lang=js&"
export * from "./confirm.vue?vue&type=script&lang=js&"
import style0 from "./confirm.vue?vue&type=style&index=0&id=124489ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124489ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/xinyu/.jenkins/workspace/vue-Commonality-CMS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124489ce')) {
      api.createRecord('124489ce', component.options)
    } else {
      api.reload('124489ce', component.options)
    }
    module.hot.accept("./confirm.vue?vue&type=template&id=124489ce&scoped=true&", function () {
      api.rerender('124489ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "oxygen/cms/components/common/confirm.vue"
export default component.exports